import { TourTypeURL } from '@/_models/Tour';
import { PAGE_PATH } from '@/components/types';

export enum TourType {
  Tour = 'tour',
  Experience = 'experience',
  ECommerce = 'e-commerce-tour',
  Kiosk = 'kiosk',
}

const getTourTypeFromUrl = (url: string): string => {
  const pathname = new URL(url).pathname;
  const pathSegments = pathname.split('/').filter(Boolean);

  if (pathSegments.length === 0) return TourTypeURL.regular;

  switch (pathSegments[0]) {
    case PAGE_PATH.TOUR:
      return TourTypeURL.regular;
    case PAGE_PATH.EXPERIENCE:
      return TourTypeURL.experience;
    case PAGE_PATH.ECOMMERCE:
      return TourTypeURL.ecommerce;
    case PAGE_PATH.KIOSK:
      return TourTypeURL.kiosk;
    default:
      return TourTypeURL.regular;
  }
};

export default getTourTypeFromUrl;
